<p-floatLabel>
  <p-autoComplete [suggestions]="businesses" (completeMethod)="searchBusiness($event.query)" field="Id"
    (onSelect)="onSelectionChanged.emit($event.value)" [forceSelection]="true" [showClear]="true"
    (onClear)="onSelectionChanged.emit()">
    <ng-template let-business pTemplate="item">
      <div class="flex align-items-center gap-2 tw-text-sm">
        <img [src]="business.UI.Logo" class="tw-w-5" />
        <div>{{business.UI.Title || business.Name || business.Id}}</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <label>Business</label>
</p-floatLabel>